"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BonusResultStateFormat = exports.EBonusButtonType = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../interface/interface");
const utils_1 = require("../TradeUtils/Share/utils");
// 适用于领取和注册弹窗的各种按钮枚举
// 各按钮会根据领取和注册返回的状态 展示不同
var EBonusButtonType;
(function (EBonusButtonType) {
    EBonusButtonType[EBonusButtonType["cancel"] = 0] = "cancel";
    EBonusButtonType[EBonusButtonType["support"] = 1] = "support";
    EBonusButtonType[EBonusButtonType["register"] = 2] = "register";
    EBonusButtonType[EBonusButtonType["claim"] = 3] = "claim";
    EBonusButtonType[EBonusButtonType["gotIt"] = 4] = "gotIt";
    EBonusButtonType[EBonusButtonType["bonusDetail"] = 5] = "bonusDetail";
    EBonusButtonType[EBonusButtonType["goForBill"] = 6] = "goForBill";
    EBonusButtonType[EBonusButtonType["goToDeposit"] = 7] = "goToDeposit";
    EBonusButtonType[EBonusButtonType["gotoOrderDetails"] = 8] = "gotoOrderDetails";
    EBonusButtonType[EBonusButtonType["gotoKycPage"] = 9] = "gotoKycPage";
})(EBonusButtonType || (exports.EBonusButtonType = EBonusButtonType = {}));
var BonusResultStateFormat;
(function (BonusResultStateFormat) {
    let PlatformType;
    (function (PlatformType) {
        PlatformType["H5"] = "H5";
        PlatformType["WEB"] = "WEB";
    })(PlatformType = BonusResultStateFormat.PlatformType || (BonusResultStateFormat.PlatformType = {}));
    // 入金条件翻译转换
    BonusResultStateFormat.getBonusTaskConditionTypeI18n = ($st, type) => {
        switch (type) {
            // 首次入金
            case interface_1.BonusConditionType.deposit_first:
                return $st("bonus_task_register_deposit_first");
            // 累计入金
            case interface_1.BonusConditionType.deposit_cumulative:
                return $st("bonus_task_register_deposit_cumulative");
            default:
                return "";
        }
    };
    // 获取注册成功后 弹窗文案
    BonusResultStateFormat.getBonusRegisterSuccessTipsConfig = ({ data, $st, dateFormatter, platformType = PlatformType.WEB, }) => {
        const isH5 = platformType === PlatformType.H5;
        const obj = {
            textDesc: [],
            title: $st("bonus_task_register_success_title"),
            tips: "",
            btnType: [EBonusButtonType.gotIt],
        };
        // 允许领取时，展示取消/去领取按钮
        if (data.sendable) {
            obj.btnType = [EBonusButtonType.cancel, EBonusButtonType.claim];
        }
        /** 非首次报名 */
        if (data.task_registered && !data.first_registered_success && !data.sendable) {
            obj.title = $st("bonus_task_dup_register_title");
            /** 入金条件未达成 */
            if (data.condition && [interface_1.BonusConditionType.deposit_cumulative, interface_1.BonusConditionType.deposit_first].includes(data.condition.type)) {
                obj.textDesc = [
                    $st("bonus_task_dup_register_deposit_not_ready", {
                        bonusDesc: data.bonus.bonus_copywriting,
                        bonusAmount: data.bonus.bonus_amount,
                        start: dateFormatter.year_second(Number(data.task.start_time)),
                        end: dateFormatter.year_second(Number(data.task.end_time)),
                        type: BonusResultStateFormat.getBonusTaskConditionTypeI18n($st, data.condition.type),
                        amount: data.condition.deposit_amount,
                    }),
                ];
                if (isH5) {
                    obj.btnType = [EBonusButtonType.goToDeposit];
                }
            }
            else {
                /** 未知条件未达成 */
                obj.textDesc = [
                    $st("bonus_task_dup_register_default_tip", {
                        bonusDesc: data.bonus.bonus_copywriting,
                        bonusAmount: data.bonus.bonus_amount,
                        start: dateFormatter.year_second(Number(data.task.start_time)),
                    }),
                ];
            }
            return obj;
        }
        /** 报名成功 但是不符合入金条件 */
        if (!data.sendable &&
            data.condition &&
            [interface_1.BonusConditionType.deposit_cumulative, interface_1.BonusConditionType.deposit_first].includes(data.condition.type)) {
            if (isH5) {
                obj.title = $st("bonus_task_register_deposit_title_h5");
                obj.textDesc = [
                    $st("bonus_task_register_deposit_content1_h5", {
                        bonusDesc: data.bonus.bonus_copywriting,
                        bonusAmount: data.bonus.bonus_amount,
                        end: dateFormatter.year_second(Number(data.task.end_time)),
                        type: BonusResultStateFormat.getBonusTaskConditionTypeI18n($st, data.condition.type),
                        amount: data.condition.deposit_amount,
                    }),
                    $st("bonus_task_register_deposit_content2_h5"),
                ];
                obj.btnType = [EBonusButtonType.goToDeposit];
            }
            else {
                obj.textDesc = [
                    $st("bonus_task_register_success_deposit_not_ready", {
                        bonusDesc: data.bonus.bonus_copywriting,
                        bonusAmount: data.bonus.bonus_amount,
                        end: dateFormatter.year_second(Number(data.task.end_time)),
                        type: BonusResultStateFormat.getBonusTaskConditionTypeI18n($st, data.condition.type),
                        amount: data.condition.deposit_amount,
                    }),
                ];
            }
            return obj;
        }
        /** 报名成功 条件是入金 入金条件已经满足 可直接领取 */
        if (data.sendable &&
            data.condition &&
            [interface_1.BonusConditionType.deposit_cumulative, interface_1.BonusConditionType.deposit_first].includes(data.condition.type)) {
            obj.textDesc = [
                $st("bonus_task_register_success_deposit_ready", {
                    bonusDesc: data.bonus.bonus_copywriting,
                    bonusAmount: data.bonus.bonus_amount,
                    type: BonusResultStateFormat.getBonusTaskConditionTypeI18n($st, data.condition.type),
                    amount: data.condition.deposit_amount,
                }),
            ];
            obj.title = $st("bonus_task_register_success_title_claim");
            obj.tips = $st("bonus_task_register_success_tips", {
                end: dateFormatter.year_second(Number(data.task.end_time)),
            });
            return obj;
        }
        /** 报名成功 条件未知 但条件已经满足 可直接领取 */
        if (data.sendable && data.condition) {
            obj.textDesc = [
                $st("bonus_task_register_success_claim_ready", {
                    bonusDesc: data.bonus.bonus_copywriting,
                    bonusAmount: data.bonus.bonus_amount,
                }),
            ];
            obj.title = isH5 ? $st("bonus_task_register_success_title_claim") : $st("bonus_task_claim_success_title_h5");
            obj.tips = $st("bonus_task_register_success_tips", {
                end: dateFormatter.year_second(Number(data.task.end_time)),
            });
            return obj;
        }
        /** 报名成功 无条件 可直接领取 */
        if (data.sendable) {
            if (isH5) {
                const { day, hour, minute, second } = (0, utils_1.getFormatTimeLasting)(Number(data.task.end_time) - Date.now());
                obj.tips = $st("bonus_task_register_success_tips_h5", { day, hour, minute, second });
                obj.textDesc = [
                    $st("bonus_task_register_success_content1_h5", { bonusAmount: data.bonus.bonus_amount }),
                    $st("bonus_task_register_success_content2_h5"),
                ];
                obj.btnType = [EBonusButtonType.goForBill];
            }
            else {
                obj.tips = $st("bonus_task_register_success_tips", {
                    end: dateFormatter.year_second(Number(data.task.end_time)),
                });
                obj.textDesc = [
                    $st("bonus_task_register_success_claim_ready", {
                        bonusDesc: data.bonus.bonus_copywriting,
                        bonusAmount: data.bonus.bonus_amount,
                    }),
                ];
            }
        }
        else {
            /** 报名成功 条件不满足 条件未知 不可直接领取 */
            obj.textDesc = [
                $st("bonus_task_register_success_condition_not_ready", {
                    bonusDesc: data.bonus.bonus_copywriting,
                    bonusAmount: data.bonus.bonus_amount,
                }),
            ];
        }
        return obj;
    };
    // 获取注册失败后 弹窗文案
    BonusResultStateFormat.getBonusRegisterFailedTipsConfig = ({ data, $st, dateFormatter, }) => {
        // 数据异常
        const errorData = !data || !data.bonus || !data.task;
        if (errorData) {
            return {
                textDesc: [$st("bonus_task_register_failed_error_content")],
                title: $st("bonus_task_register_failed_error"),
                btnType: [EBonusButtonType.cancel, EBonusButtonType.support],
            };
        }
        const obj = {
            textDesc: [
                $st("bonus_task_register_failed_default", {
                    bonusDesc: data.bonus.bonus_copywriting,
                }),
            ],
            title: $st("bonus_task_register_failed_title"),
            btnType: [EBonusButtonType.gotIt],
        };
        // 时间检验无效
        if (data.failed_reason === interface_1.BonusRegisterFailedReason.task_time_invalid) {
            const n = Date.now();
            // 未开始
            if (new trade_utils_lib_1.SafeDecimal(n).lessThan(data.task.start_time)) {
                obj.textDesc = [
                    $st("bonus_task_register_failed_not_start", {
                        bonusDesc: data.bonus.bonus_copywriting,
                        start: dateFormatter.year_second(Number(data.task.start_time)),
                    }),
                ];
                obj.title = $st("bonus_task_register_failed_title_start");
                return obj;
            }
            // 已结束
            if (new trade_utils_lib_1.SafeDecimal(n).greaterThan(data.task.end_time)) {
                obj.textDesc = [
                    $st("bonus_task_register_failed_after_end", {
                        bonusDesc: data.bonus.bonus_copywriting,
                        end: dateFormatter.year_second(Number(data.task.end_time)),
                    }),
                ];
                obj.title = $st("bonus_task_register_failed_title_end");
                return obj;
            }
            return obj;
        }
        // 仅限邀请用户
        if (data.failed_reason === interface_1.BonusRegisterFailedReason.only_invited) {
            obj.textDesc = [
                $st("bonus_task_register_failed_only_invited", {
                    bonusDesc: data.bonus.bonus_copywriting,
                }),
            ];
            return obj;
        }
        // 仅限新用户
        if (data.failed_reason === interface_1.BonusRegisterFailedReason.only_newly_user) {
            obj.textDesc = [
                $st("bonus_task_register_failed_only_newly_user", {
                    bonusDesc: data.bonus.bonus_copywriting,
                }),
            ];
            return obj;
        }
        // 仅限未交易过合约的用户
        if (data.failed_reason === interface_1.BonusRegisterFailedReason.only_no_future_traded) {
            obj.textDesc = [
                $st("bonus_task_register_failed_only_future_traded", {
                    bonusDesc: data.bonus.bonus_copywriting,
                }),
            ];
            return obj;
        }
        return obj;
    };
    // 获取领取失败后 弹窗文案
    BonusResultStateFormat.getBonusClaimFailedTipsConfig = ({ data, $st, dateFormatter, setNeedKycView = () => { }, platformType = PlatformType.WEB, }) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        const obj = {
            title: $st("bonus_claim_error_bonus_default"),
            textDesc: [
                $st("bonus_claim_error_bonus_default_content") +
                    `${((_a = data.failed_info) === null || _a === void 0 ? void 0 : _a.failed_reason) ? `\n${(_b = data.failed_info) === null || _b === void 0 ? void 0 : _b.failed_reason}` : ""}`,
            ],
            btnType: [EBonusButtonType.cancel, EBonusButtonType.support],
            needKycView: false,
        };
        // 服务端没有返回 bonus信息或者task信息，
        // 一般情况下是id无效造成的
        if (!data.bonus || !data.task) {
            return obj;
        }
        // 不在活动时间范围内
        if (new trade_utils_lib_1.SafeDecimal(Date.now()).lessThan(data.task.start_time)) {
            obj.title = $st("bonus_task_register_failed_title_start");
            obj.textDesc = [
                $st("bonus_claim_error_not_start", {
                    bonusDesc: data.bonus.bonus_copywriting,
                    start: dateFormatter.year_second(Number(data.task.start_time)),
                }),
            ];
            obj.btnType = [EBonusButtonType.gotIt];
            return obj;
        }
        if (new trade_utils_lib_1.SafeDecimal(Date.now()).greaterThan(data.task.end_time)) {
            obj.title = $st("bonus_task_register_failed_title_end");
            obj.textDesc = [
                $st("bonus_claim_error_after_end", {
                    bonusDesc: data.bonus.bonus_copywriting,
                    end: dateFormatter.year_second(Number(data.task.end_time)),
                }),
            ];
            obj.btnType = [EBonusButtonType.gotIt];
            return obj;
        }
        // 报名成功 不满足入金条件 不能领取
        if (data.task_registered &&
            !data.sendable &&
            ((_c = data.failed_info) === null || _c === void 0 ? void 0 : _c.failed_reason) &&
            [interface_1.BotBonusFailReason.duplicate_collect].includes(data.failed_info.failed_reason)) {
            obj.title = $st("bonus_claim_error_duplicate");
            obj.textDesc = [
                $st("bonus_claim_error_duplicate_content", {
                    bonusDesc: data.bonus.bonus_copywriting,
                    bonusAmount: data.bonus.bonus_amount,
                }),
            ];
            obj.btnType = [EBonusButtonType.cancel, EBonusButtonType.bonusDetail];
            if (platformType === PlatformType.H5) {
                obj.btnType = [EBonusButtonType.goForBill];
            }
            return obj;
        }
        // 未报名
        if (!data.task_registered) {
            obj.title = $st("bonus_claim_error_not_register");
            obj.textDesc = [$st("bonus_claim_error_not_register_content", { bonusDesc: data.bonus.bonus_copywriting })];
            obj.btnType = [EBonusButtonType.cancel, EBonusButtonType.register];
            return obj;
        }
        // 报名成功 不满足入金条件 不能领取
        if (data.task_registered &&
            !data.sendable &&
            ((_d = data.failed_info) === null || _d === void 0 ? void 0 : _d.failed_reason) &&
            [interface_1.BotBonusFailReason.first_deposit_not_enough, interface_1.BotBonusFailReason.cumulative_deposit_not_enough].includes(data.failed_info.failed_reason)) {
            const typeTransfer = {
                [interface_1.BotBonusFailReason.first_deposit_not_enough]: interface_1.BonusConditionType.deposit_first,
                [interface_1.BotBonusFailReason.cumulative_deposit_not_enough]: interface_1.BonusConditionType.deposit_cumulative,
            }[data.failed_info.failed_reason];
            obj.title = $st("bonus_claim_error_condition_not_ready");
            obj.textDesc = [
                $st("bonus_claim_error_deposit_not_ready_content", {
                    bonusDesc: data.bonus.bonus_copywriting,
                    bonusAmount: data.bonus.bonus_amount,
                    end: dateFormatter.year_second(Number(data.task.end_time)),
                    type: BonusResultStateFormat.getBonusTaskConditionTypeI18n($st, typeTransfer),
                    amount: ((_e = data.failed_info) === null || _e === void 0 ? void 0 : _e.deposit_amount) || "",
                }),
            ];
            obj.btnType = platformType === PlatformType.H5 ? [EBonusButtonType.goToDeposit] : [EBonusButtonType.gotIt];
            return obj;
        }
        // 报名成功 不满足kyc条件 不能领取
        if (data.task_registered &&
            !data.sendable &&
            ((_f = data.failed_info) === null || _f === void 0 ? void 0 : _f.failed_reason) &&
            [interface_1.BotBonusFailReason.need_kyc].includes(data.failed_info.failed_reason)) {
            obj.needKycView = true;
            setNeedKycView(true);
            return obj;
        }
        // 存在未使用的发财金
        if (data.task_registered &&
            !data.sendable &&
            ((_g = data.failed_info) === null || _g === void 0 ? void 0 : _g.failed_reason) &&
            ((_h = data.failed_info) === null || _h === void 0 ? void 0 : _h.failed_reason) === interface_1.BotBonusFailReason.exist_not_used_bonus) {
            obj.title = $st("bonus_claim_error_bonus_un_use");
            obj.textDesc = [$st("bonus_claim_error_bonus_un_use_content")];
            obj.btnType = [EBonusButtonType.cancel, EBonusButtonType.bonusDetail];
            if (platformType === PlatformType.H5) {
                obj.btnType = [EBonusButtonType.goForBill];
            }
            return obj;
        }
        // 存在未领取的发财金
        if (data.task_registered &&
            !data.sendable &&
            ((_j = data.failed_info) === null || _j === void 0 ? void 0 : _j.failed_reason) &&
            ((_k = data.failed_info) === null || _k === void 0 ? void 0 : _k.failed_reason) === interface_1.BotBonusFailReason.exist_not_collect_bonus) {
            obj.title = $st("bonus_claim_error_bonus_un_use");
            obj.textDesc = [$st("bonus_claim_error_bonus_un_collect_content")];
            obj.btnType = [EBonusButtonType.gotIt];
            return obj;
        }
        // 发财金 超出预算 过期 不存在的情况
        if (data.task_registered &&
            !data.sendable &&
            (!data.bonus ||
                !data.task ||
                (((_l = data.failed_info) === null || _l === void 0 ? void 0 : _l.failed_reason) &&
                    [interface_1.BotBonusFailReason.bonus_expire, interface_1.BotBonusFailReason.bonus_not_exist, interface_1.BotBonusFailReason.exceed_budget].includes((_m = data.failed_info) === null || _m === void 0 ? void 0 : _m.failed_reason)))) {
            return obj;
        }
        // 报名成功 不满足领取条件 条件未知 不能领取
        if (data.task_registered && !data.sendable && ((_o = data.failed_info) === null || _o === void 0 ? void 0 : _o.failed_reason)) {
            obj.title = $st("bonus_claim_error_condition_not_ready");
            obj.textDesc = [
                $st("bonus_claim_error_condition_not_ready_content", {
                    bonusDesc: data.bonus.bonus_copywriting,
                    bonusAmount: data.bonus.bonus_amount,
                    end: dateFormatter.year_second(Number(data.task.end_time)),
                }),
            ];
            obj.btnType = [EBonusButtonType.gotIt];
            return obj;
        }
        return obj;
    };
    // 领取成功文案
    BonusResultStateFormat.getBonusClaimSuccessTipsConfig = ({ data, $st, dateFormatter, platformType, }) => {
        const { day, hour, minute, second } = (0, utils_1.getFormatTimeLasting)(Number(data.task.end_time) - Date.now());
        const isH5 = platformType === PlatformType.H5;
        const obj = {
            textDesc: [],
            title: $st("bonus_task_register_success_title"),
            tips: $st("bonus_task_claim_success_tips_h5", { day, hour, minute, second }),
            btnType: [EBonusButtonType.gotIt],
        };
        if (isH5) {
            obj.title = $st("bonus_task_claim_success_title_h5");
            obj.tips = $st("bonus_task_claim_success_tips_h5", { day, hour, minute, second });
            obj.textDesc = [
                $st("bonus_task_claim_success_content1_h5", { info: data.bonus.bonus_copywriting, bonusAmount: data.bonus.bonus_amount }),
                $st("bonus_task_claim_success_content2_h5"),
            ];
            obj.btnType = [EBonusButtonType.goForBill];
        }
        return obj;
    };
    // 未登录提示
    BonusResultStateFormat.getBonusUnloginTipsConfig = ({ data, $st, dateFormatter, platformType, }) => {
        const isH5 = platformType === PlatformType.H5;
        const obj = {
            textDesc: [],
            title: $st("bonus_task_register_login_title_h5"),
            tips: "",
            btnType: [],
        };
        if (!data || !data.bonus || !data.task) {
            obj.title = $st("bonus_task_register_failed_error");
            obj.tips = $st("bonus_task_register_failed_error_content");
            return obj;
        }
        const bonusData = data === null || data === void 0 ? void 0 : data.bonus;
        const n = Date.now();
        // 未开始
        if (new trade_utils_lib_1.SafeDecimal(n).lessThan(data.task.start_time)) {
            obj.tips = $st("bonus_task_register_failed_not_start", {
                bonusDesc: data.bonus.bonus_copywriting,
                start: dateFormatter.year_second(Number(data.task.start_time)),
            });
            obj.textDesc = [$st("bonus_task_register_failed_title_start")];
            return obj;
        }
        // 已结束
        if (new trade_utils_lib_1.SafeDecimal(n).greaterThan(data.task.end_time)) {
            obj.tips = $st("bonus_task_register_failed_after_end", {
                bonusDesc: data.bonus.bonus_copywriting,
                end: dateFormatter.year_second(Number(data.task.end_time)),
            });
            obj.textDesc = [$st("bonus_task_register_failed_title_end")];
            return obj;
        }
        if (isH5) {
            obj.title = $st("bonus_task_register_login_title_h5");
            obj.textDesc = bonusData ? [$st("bonus_task_register_login_bonus_amount_h5", { bonusAmount: bonusData.bonus_amount })] : [];
            obj.tips = bonusData ? bonusData.bonus_copywriting : $st("bonus_task_register_login_failed_desc");
        }
        return obj;
    };
})(BonusResultStateFormat || (exports.BonusResultStateFormat = BonusResultStateFormat = {}));
